import { shallowMount } from "@vue/test-utils";
import ProductImageContainer from "@/components/core/ProductImageContainer";

describe("ProductImageContainer component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ProductImageContainer);
  });

  it("Renders del component ProductImageContainer", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
